import List from 'list.js';

export function dictionaryArchive() {
  const listContent = new List('list-container', {
    valueNames: [
      'js-title',
      { attr: 'data-yomi', name: 'js-list-item' },
    ],
    listClass: 'js-list'
  })

  const inputSearch = document.querySelector('.js-list-search')
  const searchContainer = document.querySelector('.js-list-search-container')
  const buttonClearInput = document.querySelector('.js-clear-input')
  const resultCount = document.querySelectorAll('.js-list-count')
  const stickyContainer = document.querySelectorAll('.js-sticky-sidebar-container')
  const sticky = document.querySelectorAll('.js-sticky-sidebar')
  
  if (inputSearch) {
    inputSearch.addEventListener('input', function () {
      if (inputSearch.value !== '') {
        searchContainer.classList.add('is-searching')
      } else {
        searchContainer.classList.remove('is-searching')
      }
    })
  }
  if (buttonClearInput) {
    buttonClearInput.addEventListener('click', function (e) {
      inputSearch.value = ''
      searchContainer.classList.remove('is-searching')
      listContent.search()
      e.preventDefault()
    })
  }
  const updatedList = function (e) {
    if (stickyContainer.length) {
      for (let i = 0; i < stickyContainer.length; i++) {
        const el = stickyContainer[i]
        el.removeAttribute('style')
      }
    }
    if (sticky.length) {
      for (let i = 0; i < sticky.length; i++) {
        const el = sticky[i]
        el.removeAttribute('style')
      }
    }
    if (resultCount.length) {
      for (let i = 0; i < resultCount.length; i++) {
        const el = resultCount[i]
        el.innerHTML = e.matchingItems.length
      }
    }
  }
  listContent.on('updated', updatedList)
}